import React, { useEffect } from 'react'
import Alert from '../../../itrust_common/components/Alert'
import { claimFormCreate } from '../../../redux/actions/order/claimFormActions'
import { orderLoad } from '../../../redux/actions/order/orderActions'
import { connect } from 'react-redux';
import { getInsuranceFromRPAServices, isRpaVerifiedInsurance } from '../../../containers/authorised/addOns/other/AddOnsHelperFunctions'
import { getInsuranceType } from '../../../itrust_common/components/HelperFunctions';
import { visionInsuranceServicesLoad } from '../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceAction';
import { visionInsuranceClaimFormCreate, visionInsuranceClaimFormLoad } from '../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction';
import RpaClaimFormGenerate from '../../../containers/authorised/addOns/rpa/vision_insurance/claimForm/generateClaim/RpaClaimFormGenerate';
import useInsuranceMappedFailed from '../../../containers/authorised/addOns/rpa/vision_insurance/useInsuranceMappedFailed';

function GenerateClaimFormButton(props) {
  const { dispatch, order, handleTabChange, visionInsuranceConfig, services } = props

  const { rpaVerificationFailed, insuranceVerificationFailed } = useInsuranceMappedFailed(order.patient_insurance_attributes?.insurance_name)
  const isRpaSupported = isRpaVerifiedInsurance(visionInsuranceConfig, services, order.patient_insurance_attributes?.insurance_name)

  useEffect(() => {
    let storeID = localStorage.getItem('StoreID')
    if (storeID == null) {
      // Store dropdown All selected > load RPA services from order's store_id
      dispatch(visionInsuranceServicesLoad({ store_id: order.store_id, category: "vision_insurance" }))
    }
  }, [])

  const handleGenerateClaimForm = () => {
    if (order.insurance_receivable <= 0.0) {
      Alert.confirm("This order has a receivable less than or equal to $0 and creating a 1500 claim form could lead to a claim rejection.", (res) => {
        if (res) {
          dispatch(handleClaimFormCreate)
        }
      })
    }
    else {
      handleClaimFormCreate()
    }
  }

  const handleClaimFormCreate = async () => {
    if (!order.patient_insurance_id)
      Alert.warning("Patient insurance is not selected yet, You can't generate 1500 form without patient insurance")
    else {
      await claimFormGenerate()
      await dispatch(orderLoad(order.id, { include: '*' }));
      handleTabChange(6)
    }
  }

  const handleVisionInsuranceClaimGenerate = async () => {
    const insurance = getInsuranceFromRPAServices(services, order.patient_insurance_attributes?.insurance_name)
    let rpaClaimGenerateData = { add_ons_id: insurance.id, orders_order_id: order.id, patient_id: order.patient_id, insurance_type: order.patient_insurance_attributes?.insurance_type, store_id: order.store_id, insurance_payer: order.patient_insurance_attributes?.insurance_name, service: insurance.config.service, other_details: { resource: "generate_claim" } }
    await dispatch(visionInsuranceClaimFormCreate(rpaClaimGenerateData))
    await dispatch(visionInsuranceClaimFormLoad(order.id))
    return;
  }

  const claimFormGenerate = async () => {
    if (isRpaSupported || rpaVerificationFailed) {
      if (rpaVerificationFailed){
        insuranceVerificationFailed()
      }
      else{
        await handleVisionInsuranceClaimGenerate()
      }
    }
    else {
      await dispatch(claimFormCreate(order.id))
      return;
    }
  }

  return (
    <>
      {(isRpaSupported || rpaVerificationFailed) ?
        <RpaClaimFormGenerate
          selectedInsuranceName={order.patient_insurance_attributes?.insurance_name}
          selectedInsuranceMemberId={order.patient_insurance_attributes?.member_id}
          insuranceType={getInsuranceType(order.patient_insurance_attributes?.insurance_type)}
          orderId={order.id}
          patientId={order.patient_id}
          order={order}
          services={services}
          handleGenerateClaimForm={handleGenerateClaimForm}
          dispatch={dispatch}
        /> :
        <button className="btn btn-danger mx-lg-3" onClick={handleGenerateClaimForm}>Generate Claim Form</button>
      }
    </>
  )
}

const mapStateToProps = (state) => {
  const { organisation: { organisation }, visionInsurance: { services } } = state
  return {
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance,
    services,
  }
}

export default connect(mapStateToProps)(GenerateClaimFormButton)